<div class="container container-wrapper page-container">
  <div class="row justify-content-center">
    <div class="col-xs-12 col-lg-12 col-xl-11">
      <section>
        <div class="row">
          <div *ngIf="isShowCalendar" id="ajax-load-slots-diagram" class="col-sm-6 col-xs-12 slots-diagram p-0">
            <section>
              <!-- <app-time-slot-date-selector (nextDayClick)="nextDayClick()" (prevDayClick)="prevDayClick()" [selectedDate]="selectedDate"
                [calendarService]="bookingSlotStateService"></app-time-slot-date-selector> -->
              <app-time-slot-calendar (monthChanged)="monthChanged($event)" (dateSelected)="dateSelected($event)"
                [calendarService]="bookingSlotStateService"></app-time-slot-calendar>
              <app-time-slot-diagram *ngIf="showBookingSlotsDiagram"></app-time-slot-diagram>
            </section>
          </div>
          <div class="col-xs-12 slots-time" [ngClass]="{'col-sm-6': isShowCalendar, 'col-sm-12': !isShowCalendar}">
            <div class="slots-header">
              <h3>{{ 'Start at' | translate }}</h3>
            </div>
            <div *ngIf="!isLoading && (!displayTimeSlots || displayTimeSlots.length === 0)" class="container noselect">
              <div class="row justify-content-center">
                <div class="col-12 font-weight-bold">
                  <p>
                    {{ 'Unfortunately, there are no tickets available on this day. Please select another day.' | translate }}
                  </p>
                </div>
              </div>
            </div>
            <div class="slots-time-box">
              <app-time-slot-navigation *ngIf="showBookingSlotsDiagram"></app-time-slot-navigation>
              <div class="container">
                <app-time-slots *ngIf="displayTimeSlots.length > 0" [timeSlots]="displayTimeSlots"
                  (timeSlotSelected)="onClickTimeSlot($event)"></app-time-slots>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
